import RestResource from '../rest.service';

export default class RolesService extends RestResource {
  mapFields(payload) {
    return {
      label: payload.label,
    };
  }
  mapAttach(payload) {
    return {
      permissions: payload,
    };
  }

  constructor() {
    super('roles');
  }
}
